import React, { useEffect, useState } from "react";
import api from "@/api";
import { GlassCard } from "@/components/ui-kit";
import { AlertTriangle } from "lucide-react";

export default function AnomalousHours() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/anomalous-hours?threshold=200")
      .then(({ data }) => setData(data))
      .catch(() => setData({ count: 0, items: [] }));
  }, []);

  if (!data || data.count === 0) return null;

  return (
    <GlassCard data-testid="anomalous-hours-panel">
      <div className="flex items-center gap-2 mb-1">
        <AlertTriangle className="text-amber-600" size={20} />
        <h3 className="font-head font-bold text-lg text-stone-800">مراجعة الساعات غير المعتادة ({data.count})</h3>
      </div>
      <p className="text-xs text-stone-500 mb-4">متطوعون بساعات 200 فأكثر — الساعات تُحتسب تلقائياً من المشاركات في الفرص. راجع مشاركات هؤلاء المتطوعين في صفحة «الساعات التطوعية» عند الحاجة.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-right min-w-[480px]">
          <thead>
            <tr className="text-stone-500 border-b border-amber-400/15">
              <th className="py-2 px-2 font-medium">المدرسة</th>
              <th className="py-2 px-2 font-medium">الاسم</th>
              <th className="py-2 px-2 font-medium">النوع</th>
              <th className="py-2 px-2 font-medium">الساعات</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((v) => (
              <tr key={v.id} data-testid={`anomalous-${v.id}`} className="border-b border-amber-400/10 hover:bg-amber-100/40">
                <td className="py-2 px-2 text-stone-600">{v.school_name}</td>
                <td className="py-2 px-2 text-stone-800 font-medium">{v.name}</td>
                <td className="py-2 px-2 text-stone-500">{v.type === "staff" ? "موظف" : "طالب"}</td>
                <td className="py-2 px-2 text-red-600 font-bold">{v.hours}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </GlassCard>
  );
}
